import React from "react";

import '../assets/styles/Affiliations.scss';
import aquila from '../assets/images/affiliations/aquila_aff.svg';
import cam from '../assets/images/affiliations/cam_aff.png';
import eth from '../assets/images/affiliations/eth_aff.png';
import hfa from '../assets/images/affiliations/hfa_aff.png';
import pmp from '../assets/images/affiliations/pmp_aff.png'
import hector from '../assets/images/hector_management.jpg'
import rowing from '../assets/images/affiliations/rowing_aff.png'


function Affiliations() {
    return(
    <div className="affiliations-container" id="affiliations">
        <h1>Affiliations</h1>
        <div className="affiliations-grid">

            <div className="affiliations">
                <a href="https://www.aam.ch/en/" target="_blank" rel="noreferrer"><img src={aquila} className="zoom" alt="Aquila Asset Management" width="100%"/></a>
                <a href="https://www.aam.ch/en/" target="_blank" rel="noreferrer"><h2>Aquila Asset Management</h2></a>
            </div>
            <div className="affiliations">
                <a href="https://www.cpm.uzh.ch/en.html" target="_blank" rel="noreferrer"><img src={pmp} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://www.cpm.uzh.ch/en.html" target="_blank" rel="noreferrer"><h2>PMP Zurich</h2></a>
            </div>
            <div className="affiliations">
                <a href="https://ethz.ch/de.html" target="_blank" rel="noreferrer"><img src={eth} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://ethz.ch/de.html" target="_blank" rel="noreferrer"><h2>ETH Zurich</h2></a>
            </div>
            <div className="affiliations">
                <a href="https://www.cam.ac.uk/" target="_blank" rel="noreferrer"><img src={cam} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://www.cam.ac.uk/" target="_blank" rel="noreferrer"><h2>University of Cambridge</h2></a>
            </div>
            <div className="affiliations">
                <a href="https://hector-fellow-academy.de/en/" target="_blank" rel="noreferrer"><img src={hfa} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://hector-fellow-academy.de/en/" target="_blank" rel="noreferrer"><h2>Hector Fellow Academy</h2></a>
            </div>
            <div className="affiliations">
                <a href="https://www.stedmundscollegeboatclub.com/" target="_blank" rel="noreferrer"><img src={rowing} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://www.stedmundscollegeboatclub.com/" target="_blank" rel="noreferrer"><h2>St Edmund's College Rowing-Club Cambridge</h2></a>
            </div>
        </div>
    </div>
    );
}

export default Affiliations;